import { Outlet, useParams, useSearchParams } from "react-router";
import { ProjectSidebar } from "@/components/Sidebar";
import { TaskPeek } from "@/components/tasks/TaskPeek";
import { ErrorState, PageSpinner } from "@/components/ui";
import { errorMessage, isStatus } from "@/lib/api";
import { ProjectProvider } from "@/lib/project";
import { useBundle, useMe } from "@/lib/queries";
import { Shell } from "./AppLayout";
import { NotFoundPage } from "@/pages/NotFoundPage";

export function ProjectLayout() {
  const { pid = "" } = useParams();
  const me = useMe().data!;
  const bundle = useBundle(pid);
  const [params] = useSearchParams();
  const peekId = params.get("task");

  if (bundle.isPending) return <PageSpinner />;
  if (bundle.error) {
    if (isStatus(bundle.error, 404)) return <NotFoundPage message="This project doesn't exist or you don't have access to it." />;
    return <ErrorState message={errorMessage(bundle.error)} onRetry={() => bundle.refetch()} />;
  }

  return (
    <ProjectProvider bundle={bundle.data} me={me}>
      <Shell sidebar={<ProjectSidebar />}>
        <Outlet />
      </Shell>
      {peekId && <TaskPeek taskId={peekId} />}
    </ProjectProvider>
  );
}
